import { BrowserRouter } from 'react-router-dom'
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit'
import '@rainbow-me/rainbowkit/styles.css'
import Router from './routes/index.jsx'
import { WalletAuthProvider } from './context/WalletAuthProvider'
import { DisplayStoreProvider, useDisplayStore } from './context/DisplayStoreProvider'
import { WalletActionsProvider, useWalletActions } from './context/WalletActionsProvider'
import SolanaProviders from './context/SolanaProviders'
import { ThemeProvider } from './context/ThemeProvider'
import LoginModal from './components/connect/LoginModal'
import LaunchShowcaseModal from './components/modals/LaunchShowcaseModal'
import config from './utils/evm/config.js'

const queryClient = new QueryClient()

function WhatsNewHost() {
  const { isWhatsNewOpen, closeWhatsNew } = useDisplayStore()
  const { isWalletConnected } = useWalletActions()
  return (
    <LaunchShowcaseModal
      open={isWhatsNewOpen && isWalletConnected}
      onClose={closeWhatsNew}
    />
  )
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <WagmiProvider config={config}>
          <QueryClientProvider client={queryClient}>
            <RainbowKitProvider theme={darkTheme()}>
              <SolanaProviders>
                <WalletAuthProvider>
                  <DisplayStoreProvider>
                    <WalletActionsProvider>
                      <Router />
                      <LoginModal />
                      <WhatsNewHost />
                    </WalletActionsProvider>
                  </DisplayStoreProvider>
                </WalletAuthProvider>
              </SolanaProviders>
            </RainbowKitProvider>
          </QueryClientProvider>
        </WagmiProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
}

export default App
